/**
 * Person entity payload — the Lore user mirror.
 *
 * `user_id` is the link to the mirrored `lore.users` row. `null` for
 * external Git authors who have no Lore account (commits/PRs ingested
 * from outside the platform). Identifiers (handle, email, etc.) live
 * on the entity row's `slug`; richer profile fields are excluded from
 * launch per the prototype design (D10).
 *
 * Design context: docs/plans/2026-05-26-llm-wiki-entities-prototype-design.md
 */

import { z } from 'zod';

export const personPayloadSchema = z.object({
  user_id: z.string().nullable(),
});

export type PersonPayload = z.infer<typeof personPayloadSchema>;
